module.exports = __webpack_public_path__ + "static/img/sky-networks-eco.82dd5e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/sky-networks-eco.jpg
// module id = tgL6
// module chunks = 0